document.addEventListener('DOMContentLoaded', function() {
  const mediaGroup = document.querySelector('[data-product-single-media-group]');

  if (!mediaGroup || typeof jQuery === 'undefined') return;

  // Only show counter if progress bar is enabled
  if (!mediaGroup.classList.contains('slick-progress-bar')) return;

  const $slider = jQuery(mediaGroup);

  // Create counter element
  const counter = document.createElement('div');
  counter.className = 'slide-counter';

  // Insert counter into the media group wrapper
  const wrapper = document.querySelector('[data-product-single-media-group-wrapper]');
  if (wrapper) {
    wrapper.style.position = 'relative';
    wrapper.appendChild(counter);
  }

  // Update counter function
  function updateSlideCounter() {
    const current = $slider.slick('slickCurrentSlide');
    const total = $slider.find('.slick-slide').not('.slick-cloned').length;
    counter.textContent = (current + 1) + ' / ' + total;
  }

  // Wait for slick to initialize
  let attempts = 0;
  const checkSlick = setInterval(() => {
    attempts++;

    if ($slider.hasClass('slick-initialized')) {
      clearInterval(checkSlick);

      // Initial state
      updateSlideCounter();

      // Update on slide change
      $slider.on('afterChange', updateSlideCounter);
    }

    // Timeout after 50 attempts (5 seconds with 100ms intervals)
    if (attempts >= 50) {
      clearInterval(checkSlick);
    }
  }, 100);
});
